/*
    The text in the grid, and the text in DOM nodes
    No Size Adjustments Made ('unformatted') -- DOM only created once for performance
 */


var NormalizeNewLineCharacters = require('../../FV/util').normalizeNewLineCharacters;

/**
 * overlayAttributes -- taken from the page model; should probably be wrapped in a class
 */

var TextGridModel = function( overlayText, overlayAttributes ) {

    this.text = NormalizeNewLineCharacters( overlayText );

    this.nRows = 0;
    this.maxCols = 0;

    //also sets nRows, maxCols (which is really nCols)
    this.textInNonDOMMarkup = this._unformattedTextInDomNodes();

    /* Values from the overlay necessary for fn actualDimensions */
    /* Could just store oWidth, oHeight */

    this.chrWt =  1 / overlayAttributes.cpi * 96;
    this.chrHt = 1 / overlayAttributes.lpi * 96;


};

/* (unformatted -- only needs to be done once ) */
/* also sets this.nRows && this.maxCols to later retrieve the actual text dimensions (not from the DOM) */

TextGridModel.prototype._unformattedTextInDomNodes = function() {

    var delimitedTxt = this.text.split('\n'), //this puts into rows (delimits by line)
        nRows = delimitedTxt.length,
        nCols,
        aRowDivs = [],
        span,
        div,
        maxCols = 0,
        rowDiv = document.createElement('div'),
        charSpan = document.createElement('span');

    rowDiv.className = 'row';
    charSpan.className = 'char';

    for (var r=0; r < nRows; r++) {  //looping by this allows to tell the actual end of the line

        var curRowDiv = rowDiv.cloneNode();

        if (delimitedTxt[r].length > 0) { //not a line break -- this is the 'row'
            nCols = delimitedTxt[r].length;
            nCols > maxCols && (maxCols = nCols);
            for (var c = 0; c < nCols; c++) {
                span = charSpan.cloneNode();
                span.innerHTML = delimitedTxt[r][c];
                curRowDiv.appendChild(span); //don't see perf gains by using arrays with dom elements
            }
            aRowDivs.push( curRowDiv );

        } else { //line break -- print back (esp if copied text to preserve the actual whitespace)
            //for now -- spans are required in print out ... can change this ... (but if do the new lines with be off the char at the end)
            span = charSpan.cloneNode();
            span.innerHTML = '\n';
            curRowDiv.appendChild(span);
            curRowDiv.className += ' newline';
            aRowDivs.push( curRowDiv );
        }
    }

    this.nRows = nRows;
    this.maxCols = maxCols;

    return aRowDivs;
};




/* Ceil: b/c no such thing as fractional coordinates here */

TextGridModel.prototype.actualDimensions = function( scale ) {

    scale = scale || 1.0;

    // TODO: change the originals for width and height

    return {
        width: Math.ceil( this.maxCols * this.chrWt * scale ),
        height: Math.ceil( this.nRows * this.chrHt * scale )
    };

};





//now not necessary, but it is called ... so leave in to avoid run time errors
TextGridModel.prototype.destroy = function() {
  //console.log('enter destroy text grid model');
};





module.exports = TextGridModel;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/overlay/TextGridModel.js
 ** module id = 470
 ** module chunks = 0
 **/